import styled from "@emotion/styled";

export const StyledColumnSelector = styled.div`
  display: flex;
  gap: 10px;
  align-items: start;
`;

export const StyledColumnSelectorInputs = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledSelectedColumn = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.tdBackgroundColor};
  border: 2px solid ${({ theme }) => theme.colors.main[7]};
  border-radius: 10px;
  padding: 2px 5px;
`;
